import React, { useEffect } from 'react'
import styles from './ClaimCardPage.module.css'
import Navbar from '../../components/Navbar/Navbar'
import HeaderForCard from '../../components/HeaderForCard/HeaderForCard'
import CardDescription from '../../components/CardDescription/CardDescription'
import ReviewsForCards from '../../components/ReviewsForCards/ReviewsForCards'
import ClaimCardMainInformation from '../../components/ClaimCardMainInformation/ClaimCardMainInformation'
import WaitingList from '../../components/WaitingList/WaitingList'
import { OtherClaimsSection } from '../../components/OtherClaimsSection/OtherClaimsSection'
import OrdersInfoModal from '../../components/OrdersInfoModal/OrdersInfoModal'
import Loader from '../../components/UI/Loader/Loader'
import { useAppDispatch, useAppSelector } from '../../redux/types/types'
import { useNavigate, useParams } from 'react-router-dom'
import { getClaimComments, getCurrentClaim } from '../../redux/actions/claimsAction'
import { getMe } from '../../redux/actions/meAction'
import PATH from '../../navigation/path'
import {
  createRuStatusValueForClaim,
  createStyleForStatusClaim,
} from '../../utils/createStatusForClaims'
import { useClaimComments } from '../../hooks/useClaimComments'
import { useOtherClaims } from '../../hooks/useOtherClaims'
import { checkCommentPermissions } from '../../utils/checkCommentPermissions'

const ClaimCardPage: React.FC = () => {
  const [isOrderTax, setOrderTax] = React.useState(false)
  const { claimId } = useParams<{ claimId: string }>()

  const { currentClaim, isLoadingComments } = useAppSelector((state) => state.claims)
  const { token, user, userRole } = useAppSelector((state) => state.auth)

  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const { setCommentFile, isCommentLoading, postNewCommentHandler } = useClaimComments({
    claimId,
    token,
    currentClaimId: currentClaim.id,
  })

  const { otherClaims, isLoadingStatsClaims } = useOtherClaims({
    currentClaim,
    token,
    userRole,
    userCompanyId: user.employee?.company?.id,
  })

  const canComment = checkCommentPermissions(userRole, currentClaim, user)

  const onRedirectToClaimsManagementPage = () => {
    navigate(PATH.claimManagementPage)
    window.location.reload()
  }

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [claimId])

  useEffect(() => {
    if (claimId && token) {
      dispatch(getCurrentClaim({ claimId, token }))
      dispatch(getClaimComments({ requestId: claimId }))
    }
  }, [claimId, token, dispatch])

  useEffect(() => {
    if (userRole !== 'superAdmin' && userRole !== 'admin') {
      dispatch(getMe({ token }))
    }
  }, [userRole, token, dispatch])

  return (
    <div className={styles.claimCardPage}>
      <Navbar />
      <div className={styles.headerBlock}>
        <HeaderForCard
          status={
            <div className={createStyleForStatusClaim(currentClaim.status)}>
              {createRuStatusValueForClaim(currentClaim.status)}
            </div>
          }
          title='Детали заявки'
          onRedirectHandler={onRedirectToClaimsManagementPage}
        />
      </div>

      <OrdersInfoModal isOpen={isOrderTax} onClose={() => setOrderTax(!isOrderTax)} />

      <div className={styles.content}>
        <div>
          <ClaimCardMainInformation claimData={currentClaim} openModal={() => setOrderTax(true)} />
          {currentClaim.startDate && (
            <WaitingList
              platformSize={currentClaim.place.size}
              platformName={currentClaim.place.name}
              startDate={currentClaim.startDate}
              placeId={currentClaim.place.id}
            />
          )}

          {currentClaim.startDate && (
            <OtherClaimsSection otherClaims={otherClaims} isLoading={isLoadingStatsClaims} />
          )}
        </div>

        <div className={styles.leftBlock}>
          {currentClaim.description && (
            <CardDescription text={currentClaim.description ? currentClaim.description : ''} />
          )}
          {isLoadingComments ? (
            <Loader />
          ) : (
            <>
              {canComment && (
                <ReviewsForCards
                  employees={currentClaim?.user?.employee?.company?.employees}
                  setCommentFile={setCommentFile}
                  comments={currentClaim.comments}
                  postNewCommentHandler={postNewCommentHandler}
                  isLoading={isCommentLoading}
                />
              )}
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default ClaimCardPage
